<template>
    <div class="parkingPay flex-column">
        <div class="parkingPay-content">
            <div class="parkingPay-carInfo">
                <div class="parkingPay-carInfo-header flex align-center justify-between">
                    <span>{{ carInfo.plateNum }}</span>
                    <img src="@/assets/images/pay/parkingPay-money.png" alt="" />
                </div>
                <div class="parkingPay-carInfo-content">
                    <div class="carInfo-content-header">{{ carInfo.parkName }}</div>
                    <div v-if="carInfo.parkType == 1" class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-number.png" alt="" />
                        <p class="carInfo-content-item-title">泊位号</p>
                        <p class="carInfo-content-item-value">{{ carInfo.stallCode }}</p>
                    </div>
                    <div class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-long.png" alt="" />
                        <p class="carInfo-content-item-title">驶入时间</p>
                        <p class="carInfo-content-item-value">{{ carInfo.inTime }}</p>
                    </div>
                    <div class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                        <p class="carInfo-content-item-title">停车时长</p>
                        <p class="carInfo-content-item-value" style="color: #009af3">{{
                                secondToMinute(carInfo.parkingTime)
                        }}分钟</p>
                    </div>
                </div>
                <div class="parkingPay-billInfo">
                    <div class="parkingPay-billInfo-header">
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">停车费用</p>
                            <p class="parkingPay-billInfo-item-value1">{{ Number(carInfo.consume).toFixed(2) }}元</p>
                        </div>
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">已支付</p>
                            <p class="parkingPay-billInfo-item-value2">{{ Number(carInfo.realPay).toFixed(2) }}元</p>
                        </div>
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">还需支付</p>
                            <p class="parkingPay-billInfo-item-value2">{{ Number(carInfo.orderMoney).toFixed(2) }}元</p>
                        </div>
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">支付金额</p>
                            <p class="parkingPay-billInfo-item-value3">{{ Number(carInfo.realMoney).toFixed(2) }}元</p>
                        </div>
                        <div class="parkingPay-billInfo-coupon flex align-center">
                            <img class="parkingPay-billInfo-img" src="@/assets/images/pay/parkingPay-coupon.png" alt="" />
                            <p>红包/折扣券</p>
                            <div v-if="carInfo.couponMoney > 0" @click="unuseCoupon" class="no-coupon">不使用优惠券</div>
                            <div @click="toCouponList" class="parkingPay-billInfo-coupon-right flex align-center">
                                <p>{{ carInfo.couponMoney == 0 ? "暂无可用优惠券" : `优惠金额${couponMoney} 元` }}</p>

                                <!-- <p>{{ carInfo.couponMoney == 0 ? "暂无可用优惠券" : `优惠金额${carInfo.couponMoney} 元` }}</p> -->
                                <img src="@/assets/images/pay/right.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="parkingPay-billInfo-divider">
                    <div class="parkingPay-billInfo-divider-line">
                        <van-divider dashed></van-divider>
                    </div>
                </div>
                <div class="parkingPay-billInfo-footer">
                    <p class="parkingPay-billInfo-payType-text">支付方式</p>
                    <van-radio-group v-model="payType">
                        <van-cell-group :border="false">
                            <van-cell clickable @click="radio = '1'">
                                <template #title>
                                    <div class="parkingPay-footer-type flex align-center">
                                        <img src="@/assets/images/pay/wallet.png" alt="" />
                                        <div class="parkingPay-footer-payforpocket">
                                            <p>余额支付</p>
                                            <p class="parkingPay-pocket-balance">当前余额：{{ wallet }}元</p>
                                        </div>
                                    </div>
                                </template>
                                <template #right-icon>
                                    <van-radio name="1" checked-color="#009Af3" />
                                </template>
                            </van-cell>
                            <van-cell clickable @click="radio = '2'">
                                <template #title>
                                    <div class="parkingPay-footer-type flex align-center">
                                        <img src="@/assets/images/pay/wechat.png" alt="" />
                                        <div class="parkingPay-footer-payforpocket">
                                            <p>微信支付</p>
                                        </div>
                                    </div>
                                </template>
                                <template #right-icon>
                                    <van-radio name="2" checked-color="#009Af3" />
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
                <div class="parkingPay-wave-wrap">
                    <div class="parkingPay-billInfo-footer-wave"></div>
                </div>
            </div>
        </div>
        <div class="parkingPay-comfirm-btn">
            <van-button :loading="payLoading" @click="payNow" class="comfirm-btn">立即缴费</van-button>

            <!-- <van-button :loading="payLoading" :disabled="Number(carInfo.realMoney) == 0" @click="payNow" class="comfirm-btn">立即缴费</van-button> -->
        </div>

        <loading :show="payLoading" text="支付中..." />
    </div>
</template>

<script>
import { secondToMinute, throttleBytimestamp, obj2Param } from "@/libs/tools";
import Loading from "@/components/base/loading/loading.vue";
import { queryMyParkingRecordDetail, queryBindPlateNumAndCouponNum, submitParkingOrderFromApp, queryBestSuitCoupon, listMyCoupon } from "@/api/api";

export default {
    name: "ParkingPay",
    components: {
        Loading,
    },
    data() {
        return {
            carInfo: {},
            wallet: 0, //余额余额
            couponMoney: 0, //优惠券金额
            couponId: "", //优惠券Id
            payType: "2", // 1:余额支付，2：微信支付
            payLoading: false, //支付遮罩
            payStatus: 0,
            obj: {},
        };
    },

    mounted() {
        this.obj = this.$route.query;
        this.payStatus = this.obj.payStatus;

        queryMyParkingRecordDetail(this.obj).then((res) => {
            this.carInfo = res.data;
            this.getWalletMoney();
            this.getCoupon();
        });
    },
    methods: {
        secondToMinute,
        getWalletMoney() {
            //获取数据 余额余额
            queryBindPlateNumAndCouponNum({ type: 2 }).then((res) => {
                if (res.code == 200) {
                    this.wallet = res.data.walletMoney;
                }
            });
        },
        //
        getCoupon() {
            let that = this;
            //如果路由没传
            if (!this.obj.couponDetailId) {
                //获取数据 最優优惠券
                queryBestSuitCoupon({
                    needPay: this.carInfo.realMoney,
                    parkCode: this.carInfo.parkCode,
                    application: this.carInfo.parkType === 1 ? 2 : 6,
                })
                    .then((res) => {
                        if (res.code == 200) {
                            this.couponMoney = res.data ? res.data.couponMoney : 0;
                            this.couponId = res.data ? res.data.couponId : "";
                            //获取到最优优惠券 需要再调一次
                            if (res.data.couponId) {
                                let obj = {
                                    couponDetailId: this.couponId,
                                    parkingRecordId: this.obj.parkingRecordId,
                                    parkType: this.obj.parkType,
                                };
                                console.log(obj);
                                queryMyParkingRecordDetail(obj).then((res) => {
                                    that.carInfo = res.data;
                                });
                            }
                        } else {
                            this.couponMoney = 0;
                            this.couponId = "";
                        }
                    })
                    .catch(() => {
                        this.couponMoney = 0;
                        this.couponId = "";
                    });
            }
            //如果路由有传
            else {
                this.couponMoney = this.obj.couponMoney;
                this.couponId = this.obj.couponDetailId;
            }
        },
        //不使用优惠券
        unuseCoupon() {
            let obj = {
                needPay: this.obj.needPay,
                parkType: this.obj.parkType,
                parkingRecordId: this.obj.parkingRecordId,
                payStatus: this.obj.payStatus,
            };

            queryMyParkingRecordDetail(obj).then((res) => {
                this.carInfo = res.data;
                this.couponMoney = 0;
                this.couponId = "";
            });
        },
        // 判断是否有优惠券
        whetherHaveCoupon() {
            const obj = {
                couponStatus: 1,
                application: this.carInfo.parkType === 1 ? 2 : 6,
                parkCode: this.carInfo.parkCode,
            };

            listMyCoupon(obj).then((res) => {
                this.haveCoupon = res.data.length ? true : false;
            });
        },
        payNow: throttleBytimestamp(function () {
            const requestObj = {
                payChannel: this.payType == 2 ? "wxpayxcx" : "walletpayxcx",
                business: "normalpay",
                parkType: this.carInfo.parkType,
                totalRealMoney: this.carInfo.realMoney,
                certId: localStorage.getItem("openId"),
                orderInfo: [
                    {
                        buyer: localStorage.getItem("userId"),
                        parkCode: this.carInfo.parkCode,
                        plateNum: this.carInfo.plateNum,
                        stallCode: this.carInfo.stallCode,
                        arrearsType: this.carInfo.arrearsType,
                        orderMoney: this.carInfo.orderMoney,
                        couponMoney: this.carInfo.couponMoney,
                        realMoney: this.carInfo.realMoney,
                        couponDetailId: this.carInfo.couponDetailId,
                        couponRandomId: this.carInfo.couponRandomId,
                        couponTicketMoney: this.carInfo.couponTicketMoney,
                        couponRandomMoney: this.carInfo.couponRandomMoney,
                        payForMoney: this.carInfo.payForMoney,
                        parkingRecordId: this.carInfo.parkingRecordId,
                        goodSubject: this.carInfo.parkType === 1 ? "路内停车小程序缴费" : "路外停车小程序缴费",
                        goodDetail: this.carInfo.parkType === 1 ? "路内停车小程序缴费" : "路外停车小程序缴费",
                        //扫码
                        scanDiscount: this.carInfo.scanDiscount,
                        scanDiscountConfigId: this.carInfo.scanDiscountConfigId,
                    },
                ],
            };
            console.log(requestObj);
            this.payLoading = true;
            submitParkingOrderFromApp(requestObj)
                .then((res) => {
                    if (this.carInfo.realMoney == 0 || this.payType == 1) {
                        this.$toast("支付成功");
                        wx.miniProgram.redirectTo({
                            url: `/pages/tab2/outPayResult/outPayResult?realMoney=${this.carInfo.realMoney}`,
                        });
                        return;
                    } else {
                        let signParam = res.data.signParam;
                        let obj = {
                            realMoney: this.carInfo.realMoney,
                            timeStamp: signParam.timeStamp,
                            nonceStr: signParam.nonceStr,
                            package: encodeURIComponent(signParam.package),
                            sign: encodeURIComponent(signParam.sign),
                            signType: signParam.signType,
                        };
                        let str = obj2Param(obj);
                        wx.miniProgram.navigateTo({
                            url: `/pages/tab2/pay/pay?${str}`,
                        });
                    }
                })
                .finally(() => {
                    this.payLoading = false;
                });
        }, 2000),
        //跳转到优惠券列表
        toCouponList() {
            if (this.payStatus == 1 || this.carInfo.realMoney > 0) {
                let obj = {
                    application: this.carInfo.parkType === 1 ? 2 : 6,
                    parkCode: this.carInfo.parkCode,
                    needPay: this.carInfo.orderMoney,
                    couponDetailId: this.couponId,
                    couponMoney: this.couponMoney,
                };
                obj = {
                    ...this.obj,
                    ...obj,


                };
                this.$router.push({ name: "Voucher", params: obj });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.no-coupon {
    margin-left: auto;
    color: #fff;
    font-size: 24px;
    border-radius: 40px;
    background-color: #ff0000;
    padding: 0 10px;
}

.parkingPay {
    .parkingPay-content {
        height: calc(~"100vh - 88px - 40px");
        padding: 12px;
        overflow: auto;

        .parkingPay-carInfo {
            width: 726px;
            height: 366px;
            background: url("~@/assets/images/pay/parkingPay-header.png")
                no-repeat;
            background-size: 100% 100%;

            .parkingPay-carInfo-header {
                width: 100%;
                height: 90px;
                padding: 24px 44px 27px;

                span {
                    font-size: 40px;
                    font-weight: 500;
                    color: #fcfcfc;
                }

                img {
                    width: 27px;
                    height: 37px;
                }
            }

            .parkingPay-carInfo-content {
                // flex: 1;
                height: 266px;
                padding: 24px 44px 27px;

                .carInfo-content-header {
                    font-size: 32px;
                    font-weight: 500;
                    color: #212121;
                    margin-bottom: 30px;
                }

                .carInfo-content-item {
                    margin-bottom: 16px;

                    .carInfo-content-item1 {
                        width: 24px;
                        height: 24px;
                    }

                    .carInfo-content-item2 {
                        width: 24px;
                        height: 28px;
                    }

                    .carInfo-content-item-title {
                        margin-left: 17px;
                        vertical-align: top;
                    }

                    .carInfo-content-item-value {
                        margin-left: auto;
                        color: #666666;
                    }
                }
            }

            .parkingPay-billInfo {
                width: 702px;
                background-color: #fff;
                margin: 0 auto;
                padding: 26px;

                .parkingPay-billInfo-header {
                    .parkingPay-billInfo-item {
                        margin-bottom: 16px;

                        .parkingPay-billInfo-item-title {
                            font-size: 30px;
                            color: #212121;
                        }

                        .parkingPay-billInfo-item-value1 {
                            color: #009af3;
                            font-size: 40px;
                        }

                        .parkingPay-billInfo-item-value2 {
                            color: #616161;
                            font-size: 30px;
                        }

                        .parkingPay-billInfo-item-value3 {
                            color: #212121;
                            font-size: 40px;
                        }
                    }

                    .parkingPay-billInfo-coupon {
                        margin-top: 20px;

                        .parkingPay-billInfo-img {
                            width: 28px;
                            height: 28px;
                            margin-right: 13px;
                        }

                        color: #666666;
                        font-size: 28px;

                        .parkingPay-billInfo-coupon-right {
                            margin-left: auto;
                            font-size: 28px;

                            img {
                                width: 12px;
                                height: 21px;
                                margin-left: 26px;
                            }
                        }
                    }
                }
            }

            .parkingPay-billInfo-divider {
                width: 702px;
                height: 30px;
                background-color: #ffffff;
                margin: 0 auto;
                position: relative;

                .parkingPay-billInfo-divider-line {
                    width: 640px;
                    position: absolute;
                    top: 14px;
                    left: 30px;
                }

                &::after {
                    position: absolute;
                    content: "";
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background-color: #f5f8fa;
                    left: -15px;
                    top: 0;
                }

                &::before {
                    position: absolute;
                    content: "";
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background-color: #f5f8fa;
                    right: -15px;
                    top: 0;
                }
            }

            .parkingPay-billInfo-footer {
                width: 702px;
                margin: 0 auto;
                padding: 26px;
                background-color: #fff;

                .parkingPay-billInfo-payType-text {
                    font-size: 30px;
                    color: #333333;
                }

                .parkingPay-footer-type {
                    img {
                        width: 40px;
                        height: 38px;
                        margin-right: 17px;
                    }

                    .parkingPay-footer-payforpocket {
                        color: #666666;
                        font-size: 28px;

                        .parkingPay-pocket-balance {
                            color: #999;
                            font-size: 24px;
                        }
                    }
                }
            }

            .parkingPay-wave-wrap {
                width: 702px;
                height: 80px;
                margin: auto;
                // background-color: red;
                position: relative;

                .parkingPay-billInfo-footer-wave {
                    width: 702px;
                    height: 30px;
                    position: absolute;
                    top: -16px;
                    background: radial-gradient(
                            circle at 50% 50%,
                            #f5f8fa 0,
                            #f5f8fa 50%,
                            transparent 0
                        ),
                        radial-gradient(
                            circle at 50% 50%,
                            #f5f8fa 0,
                            #f5f8fa 50%,
                            transparent 0
                        );
                    background-repeat: repeat-x;
                    // background-color: #fff ;
                    background-size: 30px 30px;
                    background-position: bottom;
                }
            }
        }
    }

    .parkingPay-comfirm-btn {
        width: 750px;
        height: 122px;
        margin-top: auto;
        text-align: center;
        background-color: #fff;
        color: #fff;
    }
}
</style>
<style lang="less">
.parkingPay-billInfo-divider {
    .van-divider {
        margin: 0;
    }
}

.parkingPay-billInfo-footer {
    .van-cell {
        padding: 10px 0;
    }
}
</style>
